import {chain as chainOption, getOrElse, map as mapOption, none, some} from 'fp-ts/lib/Option';
import {pipe} from 'fp-ts/lib/pipeable';

const safeParseFloat = (value: string | number | undefined) => {
  let result = value || 0;

  if (typeof result !== 'number') {
    result = parseFloat(result);
  }

  return isNaN(result) ? none : some(result);
};

const toNDecimalPlaces = (decimalPlaces: number) => (value: number) => value.toFixed(decimalPlaces);

export const toMoneyValue = (value: string | number | undefined) =>
  pipe(
    some(value),
    chainOption(safeParseFloat),
    mapOption(toNDecimalPlaces(2)),
    mapOption(parsedMoneyValue => `$${parsedMoneyValue}`),
    getOrElse(() => '$0.00')
  );

export const formatCurrency = (
  amount: number | string,
  currency: string = 'USD',
  locale: Intl.LocalesArgument = 'en-US'
) => {

  if(amount === null || amount === undefined) {
    return '';
  }
  
  const value = typeof amount === 'number' ? amount : Number(amount);

  if (!Number.isFinite(value)) {
    return '';
  }

  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currency,
  }).format(value);
};
